export const SERVER_URL = import.meta.env.VITE_SERVER_URL || 'http://localhost:3001'

export const BVA_IBAN = import.meta.env.VITE_BVA_IBAN || ''

export const apiHeader = (token?: boolean | string, isFormData?: boolean): any => {
    if (token)
        return {
            headers: { Authorization: token, 'content-type': isFormData ? 'multipart/form-data' : 'application/json' },
        }

    return { headers: { Authorization: {} } }
}
